import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingOverrides } from '@zag/core/common';
import { FormattingService } from './formatting.service';

/**
 * Formats a date value using the active locale-aware formatting context.
 *
 * Usage:
 * ```html
 * {{ myDate | zagDate }}
 * {{ myDate | zagDate : { timeZone: 'UTC' } }}
 * ```
 */
@Pipe({
  name: 'zagDate',
  pure: false,
})
export class ZagDatePipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  transform(value: Date | string | number | null | undefined, overrides?: FormattingOverrides): string {
    if (value == null) {
      return '';
    }
    return this.formattingService.formatDate(value, overrides);
  }
}
